<template>
    <div class="m-webshare">
        <h5 class="title"></h5>
        <div class="slogen">
            <p>参与活动，可获得相应好礼及情义积分，情义积分可用于解锁奖励。</p>
        </div>
        
        <div class="page-view">
            <div class="share-task">
                <div class="task-item" v-for="n in 3" :key="n">
                    <div class="task-label" :class="'t-' + n"></div>
                    <div class="t-share" :class="'t-' + n"></div>

                    <div class="share-cnt" v-if="n==1">
                        <span v-if="!code">0</span><span v-else>1</span>/1
                    </div>
                    <div class="share-cnt" v-if="n==3">
                        <span>{{level}}</span>/1
                    </div>                                                         
                    <div class="share-cnt" v-if="n==2">
                        <!-- {{ friend_list.length }}/{{ amount[n - 1] }} -->
                        {{ calc_rate(friend_list.length,amount[n - 1]) }} / {{ amount[n - 1] }}
                    </div>

                    <div class="reward-list" v-if="n == 1">
                        <div class="reward-item" v-for="(item,index) in list_1" :key="index">
                            <div class="r-wrapper">
                                <div class="pic" v-tips="item.giftId">
                                    <game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item>
                                </div>
                            </div>                            
                        </div>
                    </div>

                    <div class="reward-list" v-if="n == 2">
                        <div class="reward-item" v-for="(item,index) in list_2" :key="index">
                            <div class="r-wrapper">
                                <div class="pic" v-tips="item.giftId">
                                    <game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item>
                                </div>
                            </div>                           
                        </div>
                    </div>
                    
                    <div class="reward-list" v-if="n == 3">
                        <div class="reward-item" v-for="(item,index) in list_3" :key="index">
                            <div class="r-wrapper">
                                <div class="pic" v-tips="item.giftId">
                                    <game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item>
                                </div>
                            </div>                           
                        </div>
                    </div>
                    
                    <div class="u-btn apply" v-if="n==1" :class="{'disabled' : !code , 'dismiss' : giftRate > ( n - 1 )}" @click="apply(1)"></div>
                    <div class="u-btn apply" v-if="n==3" :class="{'disabled' : level < 1 , 'dismiss' : task.isSubmit}"  @click="task_apply(task.taskOrderId,task.subList,task.giftRate,task.finishRate)"></div>
                    <div class="u-btn apply" v-if="n==2" :class="{'disabled' : amount[n - 1] > friend_list.length , 'dismiss' : giftRate > ( n - 1 )}" @click="apply(n)"></div>
                </div>
            </div>

            <div class="u-btn share" @click="call_invite()"></div>
        </div>
    </div>
</template>

<style scoped>
.title{
    width: 1007px;
    height: 187px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/pc/title-1.png);
}

.share-task{
    display: flex;
    justify-content: space-between;
    width: 1024px;
    margin:  35px auto 0;
}

.task-item{
    position: relative;
    width: 322px;
    height: 423px;
    padding-top: 62px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/pc/share-item.png);
}

.u-btn.share{
    position: relative;
    width: 285px;
    height: 103px;
    margin: 88px auto 0;
    background-image: url(~@/assets/images/pc/btn-share.png);        
}

.t-share{
    width: 252px;
    height: 58px;
    margin: 0 auto;
    background-repeat: no-repeat;
}


.t-share.t-1{
    background-image: url(~@/assets/images/pc/share-1.png); 
}

.t-share.t-2{
    background-image: url(~@/assets/images/pc/share-2.png); 
}

.t-share.t-3{
    background-image: url(~@/assets/images/pc/share-3.png); 
}

.reward-list{
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
}

.reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 70px;
    background-image: url(~@/assets/images/pc/bg-item.png);
}

.r-wrapper{
    width: 46px;
    margin: 0 auto;
}

.r-wrapper .pic{
    width: 46px;
    height: 46px;
}

.share-cnt{
    width: 252px;
    height: 31px;
    line-height: 31px;
    margin:  20px auto 25px;
    font-size: 20px;
    color: #49392e;
    text-align: center;
    background-image: url(~@/assets/images/pc/bg-cnt.png); 
}

.u-btn.apply{
    position: absolute;
    left: 50%;
    bottom: 76px;
    transform: translateX(-50%);
    width: 179px;
    height: 67px;
    background-image: url(~@/assets/images/pc/btn-task_apply.png); 
}

.u-btn.apply.dismiss{
    position: absolute;
    left: 50%;
    bottom: 76px;
    transform: translateX(-50%);
    width: 179px;
    height: 67px;
    background-image: url(~@/assets/images/pc/btn-task_apply_dismiss.png); 
}

</style>

<script>
export default {
    data (){
        return {
            config : [],
            giftRate : 0,
            finishRate : 0,
            reward_list : [],
            friend_list : [],
            list_1 : [],
            list_2 : [],
            list_3 : [],
            amount : [1,3,6],
            code : '',
            level : 0,
            task : {},
        }
    },
    mounted (){
        this.render();
        this.task_info();
    },
    methods : {
        render (){
            var _this = this;
            
            this.$get(ajax_url_map.share_config,{
                success : (res) => {
                    _this.config = res.data['1'] ? res.data['1'] : [];
                    // _this.giftRate = res.data.giftRate;
                    // _this.finishRate = res.data.finishRate;
                    _this.reward_list = res.data['1'].aGiftList;
                    _this.list_1 = _this.reward_list.filter(e => e.userNum == 0);
                    _this.list_2 = _this.reward_list.filter(e => e.userNum == 3);
                    //_this.list_3 = _this.reward_list.filter(e => e.userNum == 6);                    
                },
                error : () => {}
            },{
                mode : 1 
            })

            this.$axios.get(ajax_url_map.task_info,{
                params : {
                    no : 't04',
                    s : true,
                }
            })
            .then(res => {
                _this.level = res.data[0].rate;
                _this.list_3 = res.data[0].subList[0].giftList;
                _this.task = res.data[0];
            },rej => {
                //_this.$toast(rej.message)
            });             
        },
        calc_rate(cnt,max){
            return Math.min(cnt,max)
        },
        task_info (){
            var _this = this;
            this.$axios.get(ajax_url_map.friend_list,{
                params : {
                    mode : 1
                }
            })
            .then(res => {
                this.friend_list = res.data.list ? res.data.list : [];
                this.giftRate = res.data.giftRate;
                this.code = res.data.code;
            },rej => {
                //_this.$toast(rej.message)
            });   
        },
        call_invite(){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }
            
            //this.$copy_modal({mode : 1});
            this.$share_modal();
        },
        apply(index){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            let giftList = [];
            if(index == 1)giftList =this.list_1;
            if(index == 2)giftList =this.list_2;
            if(index == 3)giftList =this.list_3;            
            
            this.$axios.post(ajax_url_map.share_apply,{
                index : index,
            })
            .then(
                res => {
                    //this.$toast('领取成功');
                    this.$success_modal({'text' : '奖励已发放至军师邮箱及活动页面，请及时领取' , giftList : giftList});
                    this.render();
                    this.$update_user();
                    this.task_info();
                },
                rej => {
                    this.$toast(rej.message);
                }
            )             
        },
        task_apply(tid,list,start,end){

            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            let result = [];

            this.$axios.post(ajax_url_map.task_apply,{
                orderId : tid
            })
            .then(
                res => {
                    this.$success_modal({'text' : '奖励已发放至军师邮箱及活动页面，请及时领取' , giftList : this.list_3});
                    this.render();
                },
                rej => {
                    this.$toast(rej.message);
                }
            )        
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/view/webshare.vue